import { useState, type FormEvent } from "react";
import { categories, siteStats } from "@/mocks/platforms";

interface HeroProps {
  onSearch: (value: string) => void;
}

const quickTags = ["娱乐八卦", "科技爆料", "游戏电竞", "职场热议", "校园话题"];

export default function Hero({ onSearch }: HeroProps) {
  const [value, setValue] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(value.trim());
    const target = document.getElementById("rank");
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="home" className="relative overflow-hidden bg-background-50 pt-28 md:pt-36 pb-16 md:pb-24">
      <div className="pointer-events-none absolute -top-24 -left-24 w-[380px] h-[380px] rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute top-40 right-0 w-[320px] h-[320px] rounded-full bg-accent-100/70 blur-3xl"></div>

      <div className="relative mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
              <i className="ri-flashlight-fill text-accent-600"></i>
              本周榜单已更新 · 09.08 热度复核完成
            </span>

            <h1 className="mt-6 font-heading font-bold text-foreground-950 text-[2.1rem] leading-[1.15] sm:text-5xl lg:text-[3.4rem] lg:leading-[1.12]">
              瓜圈榜
              <span className="block mt-2 text-[1.6rem] sm:text-3xl lg:text-[2.4rem] text-foreground-800">
                爆料网站排行与<span className="text-primary-600">口碑榜</span>汇总
              </span>
            </h1>

            <p className="mt-6 text-base md:text-lg leading-relaxed text-foreground-600 max-w-xl">
              想找靠谱的吃瓜阵地？这里整合了当前人气较高的爆料平台，用热度榜、口碑榜和推荐榜三种视角做汇总。从讨论最热烈到口碑最稳定的，帮你一次看清，节省一个个试错的时间。
            </p>

            <form onSubmit={handleSubmit} className="mt-8 max-w-xl" role="search">
              <div className="flex flex-col sm:flex-row gap-3 p-1.5 rounded-lg bg-background-100 border border-background-200">
                <div className="flex items-center gap-2 flex-1 px-3">
                  <span className="w-6 h-6 flex items-center justify-center text-foreground-400">
                    <i className="ri-search-line text-lg"></i>
                  </span>
                  <input
                    type="search"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder="搜索平台名称，如「瓜田社」「电竞」"
                    aria-label="搜索爆料网站"
                    className="w-full py-3 text-sm bg-transparent text-foreground-900 placeholder:text-foreground-400 outline-none"
                  />
                </div>
                <button
                  type="submit"
                  className="px-6 py-3 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查榜单
                </button>
              </div>
            </form>

            <div className="mt-5 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-500">热门搜索：</span>
              {quickTags.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => {
                    onSearch(tag);
                    const target = document.getElementById("rank");
                    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
                  }}
                  className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-900 hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="w-full h-[340px] md:h-[420px] rounded-lg overflow-hidden bg-background-200 border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20collage%20of%20stacked%20paper%20cards%20with%20coral%20red%20and%20amber%20gold%20shapes%2C%20cream%20paper%20texture%2C%20subtle%20grain%2C%20clean%20minimal%20graphic%20composition%2C%20soft%20natural%20light%20and%20long%20shadows&width=900&height=1100&seq=guaquan-hero-01&orientation=portrait"
                  alt="瓜圈榜爆料网站排行与口碑榜视觉图"
                  title="瓜圈榜 - 爆料网站排行与口碑榜汇总"
                  className="w-full h-full object-top"
                />
              </div>

              <div className="absolute -bottom-5 left-4 right-4 sm:left-6 sm:right-auto sm:w-[240px] bg-background-50 rounded-lg border border-background-200 p-4">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">本周人气榜首</span>
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-trophy-line text-xs"></i>
                  </span>
                </div>
                <p className="mt-2 font-heading text-lg font-bold text-foreground-950">瓜田社</p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>热度 98
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>评分 4.8
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px rounded-lg overflow-hidden border border-background-200 bg-background-200">
          {siteStats.map((stat) => (
            <div key={stat.id} className="bg-background-50 px-5 py-6">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={stat.icon}></i>
              </span>
              <p className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {stat.value}
                <span className="ml-1 text-sm font-normal text-foreground-500">{stat.suffix}</span>
              </p>
              <p className="mt-1 text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500"></i>不接受付费上榜
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500"></i>四个维度加权评分
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500"></i>每周热度复核
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500"></i>{categories.length - 1} 大主题分类
          </span>
        </div>
      </div>
    </section>
  );
}